module.exports = __webpack_public_path__ + "static/img/FFM.1743a805.svg";